//import FlightPlanningService from "coreeff-frontend/src/services/IpadPreview/BeforeTake-off/FlightPlanning.service.js";
import NotamsService from "../../../../../services/IpadPreview/BeforeTake-off/FlightPlanning/notams.service"

const state = {
    relatedFiles: [],
    jsonData: [],
    filteredOfpTextList: [],
    samplevalue : "",
    NotamText : "",
};
const mutations = {
    set_json_data(state, payload) {
        state.jsonData = payload;
        state.samplevalue = "test";
    }
};
const actions = {
    async getJsonDataNotams({commit,state},{FKey1,TableCode}){
        const  jsonData = await NotamsService.getJsonData(FKey1,TableCode);
        state.NotamText = jsonData[0].NotamText;

        await  commit("set_json_data",jsonData);
        return  jsonData;
    },
};

const getters = {

    ParseNotamTextDatagetters : state =>
    {
        return state.jsonData[0];
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
